<template>
  <div class='demo-app'>
    <div class='demo-app-main'>
      <p v-if="loadError" role="alert">{{ loadError }}</p>
      <!-- Spinner mientras se cargan los datos -->
      <div v-if="isLoading" class="spinner-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando datos...</span>
        </div>
      </div>
      <FullCalendar class='demo-app-calendar' :options='calendarOptions'>
        <template v-slot:eventContent="arg">
          <div @click="handleEventClick(arg)" style="cursor: pointer;">
            <!-- Ícono principal según el tipo -->
            <span v-if="arg.event.extendedProps.tipo === 'AUSENCIA JUSTIFICADA'" style="margin-right: 6px;">
              <i class="fa-solid fa-hospital"></i>
            </span>
            <span v-else-if="arg.event.extendedProps.isFestivo" style="margin-right: 6px;">
              <i class="fa-solid fa-calendar-xmark"></i>
            </span>
            <span v-else-if="arg.event.extendedProps.isJornada" style="margin-right: 6px;">
              <i class="fa-solid fa-briefcase"></i>
            </span>
            <span v-else-if="arg.event.extendedProps.isPausa" style="margin-right: 6px;">
              <i class="fa-solid fa-coffee"></i>
            </span>
            <span v-else-if="arg.event.extendedProps.isVacaciones" style="margin-right: 6px;">
              <i class="fa-regular fa-sun"></i>
            </span>
            <span v-else-if="arg.event.extendedProps.isBajaLaboral" style="margin-right: 6px;">
              <i class="fa-solid fa-notes-medical"></i>
            </span>

            <!-- Ícono adicional para incidencias -->
            <span v-if="arg.event.extendedProps.incidencia" style="margin-right: 6px;">
              <i class="fa-solid fa-exclamation"></i>
            </span>

            <!-- Texto del evento -->
            {{ arg.event.title }}
          </div>
        </template>
      </FullCalendar>
    </div>
    
    <!-- Modal para mostrar detalles del evento -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <h3>Detalles del Evento</h3>
        <p><strong>Título:</strong> {{ selectedEvent.title }}</p>
        <p><strong>Fecha:</strong> {{ selectedEvent.startStr }}</p>
        <p><strong>Tipo: </strong>
          <span v-if="selectedEvent.extendedProps && selectedEvent.extendedProps.isFestivo">
            FESTIVO CALENDARIO LABORAL
          </span>
          <span v-else-if="selectedEvent.extendedProps && selectedEvent.extendedProps.isBajaLaboral">
            BAJA LABORAL
          </span>
          <span v-else-if="selectedEvent.extendedProps && selectedEvent.extendedProps.incidencia">
            incidencia o registro extraordinario
          </span>
          <span v-else-if="selectedEvent.extendedProps && selectedEvent.extendedProps.tipo">
            {{ selectedEvent.extendedProps.tipo }}
          </span>
          <span v-else>fichaje normal</span>
        </p>
        <p v-if="selectedEvent.extendedProps.observaciones">
          <strong>Observaciones:</strong> {{ selectedEvent.extendedProps.observaciones }}
        </p>
        <p v-if="selectedEvent.extendedProps && selectedEvent.extendedProps.isBajaLaboral && selectedEvent.extendedProps.comentario">
          <strong>Comentario:</strong> {{ selectedEvent.extendedProps.comentario }}
        </p>
        <button @click="closeModal">Cerrar</button>
      </div>
    </div>
    
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import widgetAuthService from '../services/widgetAuth'
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import esLocale from '@fullcalendar/core/locales/es';

export default defineComponent({
  components: {
    FullCalendar,
  },
  data() {
    return {
      isLoading: true,
      loadError: '',
      isFestivosLoading: true,
      isJornadasLoading: true,
      isPausasLoading: true, 
      isVacacionesLoading: true,
      isBajasLaboralesLoading: true,
      showModal: false,
      selectedEvent: null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        locale: esLocale,
        initialView: 'dayGridMonth',
        events: [],
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        // Usa una función flecha para mantener el contexto
        select: (selectInfo) => { this.handleDateSelect(selectInfo) },
        eventClick: (clickInfo) => { this.handleEventClick(clickInfo) },
        eventsSet: this.handleEvents,
        eventClassNames: this.eventClassNames,
        views: {
          dayGridMonth: {
            // columnHeaderFormat: { weekday: 'long' }  // Comentar o ajustar si es necesario
          },
          timeGridWeek: {
            // columnHeaderFormat: { weekday: 'long' }
          },
          timeGridDay: {
            // columnHeaderFormat: { weekday: 'long' }
          }
        }
      },
      currentEvents: [],
    }
  },
  methods: {
    handleWeekendsToggle() {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect(selectInfo) {
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar

      calendarApi.unselect() // clear date selection

      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    },
    handleEventClick(clickInfo) {
      clickInfo.jsEvent.preventDefault(); // Evita el comportamiento por defecto
      console.log('Evento clicado:', clickInfo.event);
      this.selectedEvent = clickInfo.event;
      this.showModal = true;
    },
    handleEvents(events) {
      this.currentEvents = events
    },
    eventClassNames(arg) {
      const classes = []
      
      if (arg.event.extendedProps.isFestivo) {
        classes.push('festivo')
      }
    
      // Agrega la clase 'ausencia-justificada' si el tipo del evento es "AUSENCIA JUSTIFICADA"
      if (arg.event.extendedProps.tipo === 'AUSENCIA JUSTIFICADA') {
        classes.push('ausencia-justificada')
      }
    
      if (arg.event.extendedProps.isJornada) {
        classes.push('festivo') // o la clase que desees
      }
    
      return classes
    },
    async fetchFestivos() {
      const API_URL = widgetAuthService.backendUrl;
      const endpoint = '/api-imputacion-horas/festivos/';
      console.log(`${API_URL}${endpoint}`)
      try {
        const response = await widgetAuthService.authenticatedFetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const festivos = await response.json();
        this.populateCalendarEvents(festivos);
      } catch (error) {
        console.error('Error fetching festivos:', error);
        this.loadError = 'No se han podido cargar todos los datos del calendario. Comprueba tus permisos o vuelve a iniciar sesión.';
      } finally {
        this.isFestivosLoading = false;
        this.checkLoadingComplete();
      }
    },
    async fetchJornada() {
      const API_URL = widgetAuthService.backendUrl;
      const username = this.$route.params.username;
      const endpoint = `/api-imputacion-horas/registro-jornada/${username}/`;
      console.log(`${API_URL}${endpoint}`);

      try {
        const response = await widgetAuthService.authenticatedFetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const jornadas = await response.json();
        this.populateCalendarEventsJornada(jornadas);
      } catch (error) {
        console.error('Error fetching jornada:', error);
        this.loadError = 'No se han podido cargar todos los datos del calendario. Comprueba tus permisos o vuelve a iniciar sesión.';
      } finally {
        this.isJornadasLoading = false;
        this.checkLoadingComplete();
      }
    },
    async fetchPausas() {
      const API_URL = widgetAuthService.backendUrl;
      const username = this.$route.params.username; // Accede al parámetro de la ruta
      const endpoint = `/api-imputacion-horas/registro-pausa/${username}/`;
      console.log(`${API_URL}${endpoint}`);
      try {
        const response = await widgetAuthService.authenticatedFetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const pausas = await response.json();
        this.populateCalendarEventsPausas(pausas);
      } catch (error) {
        console.error('Error fetching pausas:', error);
        this.loadError = 'No se han podido cargar todos los datos del calendario. Comprueba tus permisos o vuelve a iniciar sesión.';
      } finally {
        this.isPausasLoading = false;
        this.checkLoadingComplete();
      }
    },
    async fetchVacaciones() {
      const API_URL = widgetAuthService.backendUrl;
      const username = this.$route.params.username; // Accede al parámetro de la ruta
      const endpoint = `/api-imputacion-horas/vacaciones/${username}/`;
      console.log(`${API_URL}${endpoint}`);
      try {
        const response = await widgetAuthService.authenticatedFetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const vacaciones = await response.json();
        this.populateCalendarEventsVacaciones(vacaciones);
      } catch (error) {
        console.error('Error fetching vacaciones:', error);
        this.loadError = 'No se han podido cargar todos los datos del calendario. Comprueba tus permisos o vuelve a iniciar sesión.';
      } finally {
        this.isVacacionesLoading = false;
        this.checkLoadingComplete();
      }
    },
    async fetchBajasLaborales() {
      const API_URL = widgetAuthService.backendUrl;
      const username = this.$route.params.username;
      const endpoint = `/api-imputacion-horas/bajas-laborales/${username}/`;
      console.log(`${API_URL}${endpoint}`);
      try {
        const response = await widgetAuthService.authenticatedFetch(`${API_URL}${endpoint}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const bajas = await response.json();
        this.populateCalendarEventsBajasLaborales(bajas);
      } catch (error) {
        console.error('Error fetching bajas laborales:', error);
        this.loadError = 'No se han podido cargar todos los datos del calendario. Comprueba tus permisos o vuelve a iniciar sesión.';
      } finally {
        this.isBajasLaboralesLoading = false;
        this.checkLoadingComplete();
      }
    },
    populateCalendarEvents(festivos) {
      const events = festivos.map(festivo => ({
        title: festivo.descripcion,
        start: festivo.fecha,
        allDay: true,
        classNames: ['festivo'], // Añadir clase festivo a los eventos
        extendedProps: {
          isFestivo: true // Propiedad extra para identificar los festivos
        }
      }));
      this.calendarOptions.events = [
        ...(this.calendarOptions.events || []),
        ...events
      ];
    },
    populateCalendarEventsJornada(jornadas) {
      const formatTime = (time) => {
        if (!time) return '';
        const [hours, minutes] = time.split(':');
        return `${hours}:${minutes}`;
      };

      const events = jornadas.map(jornada => ({
        title: `${formatTime(jornada.hora_entrada)} → ${formatTime(jornada.hora_salida)}`,
        start: jornada.dia,
        allDay: false,
        classNames: ['jornada'],
        extendedProps: {
          isJornada: true,
          horaEntrada: jornada.hora_entrada,
          horaSalida: jornada.hora_salida,
          tipo: jornada.tipo,
          incidencia: jornada.incidencia,
          observaciones: jornada.observaciones // ← Asegura que pase la propiedad 
        }
      }));

      this.calendarOptions.events = [
        ...(this.calendarOptions.events || []),
        ...events
      ];
    },
    populateCalendarEventsPausas(pausas) {
      const formatTime = (time) => {
        if (!time) return '';
        const [hours, minutes] = time.split(':');
        return `${hours}:${minutes}`;
      };

      const events = pausas.map(pausa => ({
        title: `${formatTime(pausa.hora_entrada)} → ${formatTime(pausa.hora_salida)}`,
        start: pausa.dia,
        allDay: false,
        classNames: ['pausa'],
        extendedProps: {
          isPausa: true,
          horaEntrada: pausa.hora_entrada,
          horaSalida: pausa.hora_salida,
          tipo: pausa.tipo,
          incidencia: pausa.incidencia,
          observaciones: pausa.observaciones  // ← Importante para que se muestre en el modal
        }
      }));

      this.calendarOptions.events = [
        ...(this.calendarOptions.events || []),
        ...events
      ];
    },
    populateCalendarEventsVacaciones(vacaciones) {
      const events = vacaciones.map(vacacion => ({
        title: "vacaciones",
        start: vacacion.fecha,
        allDay: true,
        classNames: ['vacaciones'],
        extendedProps: {
          isVacaciones: true,
        }
      }));

      this.calendarOptions.events = [
        ...(this.calendarOptions.events || []),
        ...events
      ];
    },
    populateCalendarEventsBajasLaborales(bajas) {
      const events = bajas.map(baja => ({
        title: baja.comentario || "Baja laboral",
        start: baja.fecha,
        allDay: true,
        classNames: ['baja-laboral'],
        extendedProps: {
          isBajaLaboral: true,
          comentario: baja.comentario,
        }
      }));

      this.calendarOptions.events = [
        ...(this.calendarOptions.events || []),
        ...events
      ];
    },
    checkLoadingComplete() {
    // Verifica si todos los estados de carga son falsos
    if (!this.isFestivosLoading && !this.isJornadasLoading && !this.isPausasLoading && !this.isVacacionesLoading && !this.isBajasLaboralesLoading) {
      this.isLoading = false;
    }
  },
    closeModal() {
      this.showModal = false;
      this.selectedEvent = null;
    },
  },
  mounted() {
    this.fetchFestivos();
    this.fetchJornada();
    this.fetchPausas();
    this.fetchVacaciones();
    this.fetchBajasLaborales();
  }
})
</script>

<style lang='css'>

/* Spinner overlay */
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Asegúrate de que el spinner esté sobre el contenido */
}
/* Estilos CSS aquí */
h2 {
  margin: 0;
  font-size: 16px;
}

ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}

li {
  margin: 1.5em 0;
  padding: 0;
}

.event-content {
  display: flex;
  align-items: center;
}

.event-icon {
  margin-right: 8px;
  /* Espacio entre el ícono y la descripción */
}

.event-description {
  display: flex;
  flex-direction: column;
}

b {
  /* used for event dates/times */
  margin-right: 3px;
}

.demo-app {
  display: flex;
  min-height: 100%;
  font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
  font-size: 14px;
}

.demo-app-sidebar {
  width: 300px;
  line-height: 1.5;
  background: #eaf9ff;
  border-right: 1px solid #d3e2e8;
}

.demo-app-sidebar-section {
  padding: 2em;
}

.demo-app-main {
  flex-grow: 1;
  padding: 3em;
}

.fc {
  /* the calendar root */
  max-width: 1100px;
  margin: 0 auto;
}

.festivo {
  background-color: red !important;
  border-color: red !important;
  color: white !important;
  /* Texto blanco */
  font-size: 0.7em;
}

.vacaciones {
  background-color: rgb(25, 0, 255) !important;
  border-color: rgb(25, 0, 255) !important;
  color: white !important;
  /* Texto blanco */
  font-size: 0.7em;
}

.jornada {
  background-color: green !important;
  /* Fondo verde */
  border-color: green !important;
  /* Borde verde */
  color: white !important;
  /* Texto blanco */
  font-size: 0.7em;
  /* Tamaño de fuente más pequeño (ajusta según sea necesario) */
  display: flex;
  /* Flexbox para centrar el contenido */
  align-items: center;
  /* Centra verticalmente */
  justify-content: center;
  /* Centra horizontalmente */
  text-align: center;
  /* Centra el texto */
}

.pausa {
  background-color: rgb(150, 136, 12) !important;
  /* Fondo verde */
  border-color: rgb(150, 136, 12) !important;
  /* Borde verde */
  color: white !important;
  /* Texto blanco */
  font-size: 0.7em;
  /* Tamaño de fuente más pequeño (ajusta según sea necesario) */
  display: flex;
  /* Flexbox para centrar el contenido */
  align-items: center;
  /* Centra verticalmente */
  justify-content: center;
  /* Centra horizontalmente */
  text-align: center;
  /* Centra el texto */
}

.jornada .fc-event-title {
  color: white !important;
  font-size: 0.7em !important;
  /* Tamaño de fuente más pequeño para el título */
}

.fc-event .fc-event-title {
  text-align: center;
  /* Centra el texto dentro del evento */
  display: block;
  /* Asegura que el texto ocupe todo el contenedor */
  margin: 0;
  /* Elimina márgenes para centrado preciso */
}

/* Ajusta el color y elimina el subrayado de los números de los días */
.fc-daygrid-day-number {
  color: inherit; /* Cambia esto si quieres un color diferente */
  text-decoration: none; /* Elimina el subrayado */
}

/* Ajusta el color y elimina el subrayado de las cabeceras de los días de la semana */
.fc-col-header-cell {
  color: inherit; /* Cambia esto si quieres un color diferente */
  text-decoration: none; /* Elimina el subrayado */
}

/* Opcional: Estilo adicional para el calendario si es necesario */
.fc-daygrid-day-top {
  color: inherit; /* Cambia esto si quieres un color diferente para el texto del encabezado de cada día */
}

/* Opcional: Si también necesitas ajustar los días en el modo agenda */
.fc-daygrid-day-events {
  color: inherit; /* Cambia esto si quieres un color diferente para los eventos del día */
}

/* Cambia el color de fondo de los encabezados de los días de la semana a negro */
.fc-col-header-cell {
  background-color: black; /* Fondo negro */
  color: white; /* Texto blanco */
  text-decoration: none; /* Elimina el subrayado */
}

.fc-col-header-cell {
  background-color: black; /* Fondo negro */
  color: white; /* Texto blanco */
  text-decoration: none; /* Elimina el subrayado */
  border: none; /* Elimina el borde si es necesario */
}

/* Opcional: Ajusta el tamaño y estilo de la fuente si es necesario */
.fc-col-header-cell {
  font-size: 1em; /* Cambia el tamaño de la fuente si es necesario */
  font-weight: normal; /* Ajusta el peso de la fuente si es necesario */
}

/* Cambia el color del texto en el encabezado a blanco */
.fc-col-header-cell-cushion {
  color: white !important; /* Texto blanco */
  text-decoration: none !important; /* Elimina el subrayado */
}

/* Cambia el fondo del encabezado de los días de la semana a negro */
.fc-col-header-cell {
  background-color: black !important; /* Fondo negro */
  color: white !important; /* Texto blanco */
  border: none !important; /* Elimina el borde si es necesario */
  text-align: center; /* Opcional: centra el texto */
}

/* Opcional: Si hay un enlace dentro del encabezado, asegúrate de que no tenga subrayado */
.fc-col-header-cell-cushion a {
  text-decoration: none !important; /* Elimina el subrayado de los enlaces */
  color: inherit; /* Usa el color heredado */
}

/* Estilos para el modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-content {
  background-color: #fff !important; /* Asegura un fondo blanco */
  padding: 1em 2em;
  border-radius: 5px;
  max-width: 500px;
  width: 90%;
}

.ausencia-justificada {
  background-color: #ff6666 !important; /* Un rojo más claro que el festivo */
  border-color: #ff6666 !important;
  color: white !important;
  font-size: 0.7em;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.baja-laboral {
  background-color: #e67e22 !important; /* Naranja */
  border-color: #e67e22 !important;
  color: white !important;
  font-size: 0.7em;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
